





























































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex'; 
import { store, StoreState, AppSettings } from '../../store';
import * as moment from 'moment';
import axios from 'axios';   
import { setInterval } from 'timers';
import DatePicker from 'vue2-datepicker';
import jsPDF from 'jspdf';    
import { Packer } from 'docx';     
import {saveAs} from 'file-saver';     
import htmlDocx from 'html-docx-js/dist/html-docx';    
import XLSX from 'xlsx'; 
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';       
import { isNull } from 'util';

declare interface textMessage {  
		id: string;
		messageId: string;
		from: string;
		to: string;
		text: string;
		time: string;
		direction: "in" | "out";
		state: "received" | "queued" | "sending" | "sent" |"error";
		media: string[];
		temp_Textlist:any[];
		MsgNumbers:any[];
		_hour:number;
		_minite:number,
		EnableMSG_Number:number,
	}

declare interface selectedNumber {
 phone_number: string;
 text_permissions_level: "none" | "read_only" | "full_access";
}

declare interface TextMessagesData {
 selectedNumber: any;
 messages: textMessage[];
 textContent: string;
}

@Component({
	components: {
   	RotateSquare2,VueElementLoading 
	},
	computed: {
		...mapState({
		'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
		'text_history': (state: StoreState) => state.dashboard.text_history,
		'textmessage_limit': (state: StoreState) => state.dashboard.textmessage_limit,
		'incoming_text': (state: StoreState) => state.dashboard.incoming_text,
		'number_being_called': (state: StoreState) => state.dashboard.number_being_called,
		'incommingmessagenotification': (state: StoreState) => state.dashboard.incommingmessagenotification,
		'notifications': (state: StoreState) => state.dashboard.notifications,
		'load_more_text': (state: StoreState) => state.dashboard.load_more_text,
		'onchange_textnumber':(state: StoreState) => state.dashboard.Onchange_textnumber,  
		'Onchange_textnumberstatus':(state: StoreState) => state.dashboard.Onchange_textnumberstatus, 
		'focus_ontext':(state: StoreState) => state.dashboard.foucuson_text,  
		'text_permission_acces':(state: StoreState) =>state.account.text_permissions,
		}),
	},
	beforeDestroy() {
			////Befor destroy clear date values
			this.$store.commit('SET_ONCHANGETEXTNUMBER_STATUS',false); 
	},
	mounted(){
		
	}
})

export default class TextMessages extends Vue {
selectedContact!: object;
downloading:boolean=false;

data() {
		return {
		open: false,
		selectedNumber: null,
		messages: [],  
		textContent: "",
		date_status: false,   
		timestamp: '',
		outbound_start_timestamp: null,
		inbound_start_timestamp: null,
		daterange: null,
		sendingText: false,
		sendingImage: false,
		Loader:false,
		temp_Textlist:[],
		MsgNumbers:[],
		msg_que:[],
		Main_Number:'',
		Mobile_Number:'',
		downloadIMG:'img/icons/Download-icon1.png',
		AddContact:"/img/icons/add-contact-button.png",
		EnableMSG_Number:'',
		text_focus:'',
		minDate : '',
		maxDate :'',
		maxtodayDate:'',
		FROM_DATEL:'',
		TO_DATEL:'',
		_hour:0,
		_minite:0,
		start_date: null,
		end_date: null,

		from_number:[],
		FromSelected_Number:'',
		zoom_image:false,
		Zoomer_image:'',
		_sdate:'',
		_edate:'',
		textsmessage_status:false, 
		  __value: "",
		} as TextMessagesData
		}

	created() {   
		//this.$data.maxDate= new Date();
	var filtered = (this as any).text_permission_acces.filter(function (el) {
		return el.text_permissions_level == "full_access";
		});
		this.$data.from_number=filtered;
				//this.$data.FromSelected_Number=sltd_num[0].phone_number;
		this.$data.maxtodayDate=this.$data.maxDate=this.$data.maxDate=new Date();
		if(this.tileEnabled)
		this.$data.temp_Textlist=(this as any).text_history.slice();
		this.getTexts();
		//this.loadCheck();
		this.Contact_numbers;
		this.$data.EnableMSG_Number=(this as any).onchange_textnumber;
		var scrolldown;
		//scrolldown = setTimeout(this.scroTobottom, 1000);
	}  

	modalImage_zoom(media){
		this.$data.Zoomer_image=media;
		this.$data.zoom_image=!this.$data.zoom_image;//true;
	}


		auto_grow(element) 
		{
		this.$data.textsmessage_status=true;
		var myDiv=(this as any).$refs.text_log_123;
		myDiv.style.padding="5px";
		var objDiv = document.getElementById("your_div");
		myDiv.style.height ="10px";//'auto'; 
		myDiv.style.height = (myDiv.scrollHeight+2)+ "px";
		objDiv.style.maxHeight=(388-myDiv.scrollHeight)+"px";   
		if((428-myDiv.scrollHeight)< objDiv.clientHeight ){
		objDiv.style.maxHeight=(428-myDiv.scrollHeight)+"px";
		}
		objDiv.scrollTop = objDiv.scrollHeight;
      }

	toggle()
	 {
	this.$data.open = !this.$data.open;
	}

	close() 
	{
	this.$data.open = false;
	}
							


setmindate(){  
	this.$data.date_status=false;
	this.$data.minDate = new Date(this.$data.start_date);
	var even=this.$data.start_date;
	var dd1 = even.getDate() < 10 ?'0'+ even.getDate()  : even.getDate() ;
	var mm1 = (even.getMonth() + 1) < 10 ?'0' +(even.getMonth() +1): (even.getMonth()+1) ;
	var yyyy1 = even.getFullYear();
	var from_date=yyyy1+''+mm1;
	var _fromdate=yyyy1+'/'+mm1+'/'+dd1;
	this.$data.FROM_DATEL=_fromdate;
	var E_even=this.$data.end_date==null ? new Date() : this.$data.end_date;
	var dd2 = E_even.getDate() < 10 ?'0'+ E_even.getDate()  : E_even.getDate() ;
	var mm2 = (E_even.getMonth() + 1) < 10 ?'0' +(E_even.getMonth() +1): (E_even.getMonth()+1) ;
	var yyyy2 = E_even.getFullYear();  
	var to_date=yyyy2+''+mm2;
	var _todate=yyyy2+'/'+mm2+'/'+dd2; 
}

setmaxdate(){
	this.$data.date_status=false;
	this.$data.maxDate = new Date(this.$data.end_date);  
	var even=this.$data.end_date;
	var dd2 = even.getDate() < 10 ?'0'+ even.getDate()  : even.getDate() ;
	var mm2 = (even.getMonth() + 1) < 10 ?'0' +(even.getMonth() +1): (even.getMonth()+1) ;
	var yyyy2 = even.getFullYear();  
	var to_date=yyyy2+''+mm2;
	var _todate=yyyy2+'/'+mm2+'/'+dd2;  
	this.$data.TO_DATEL=_todate;
	//	this.getTexts_bydate111113(this.$data.FROM_DATEL,this.$data.TO_DATEL)
}

Text_URL(text){
		var str =text;
		if(str!=undefined){
		var regex = /((?:ftp|http|https):\/\/(?:\w+:{0,1}\w*@)?(?:\S+)(?::[0-9]+)?(?:\/|\/(?:[\w#!:.?+=&%@!-/]))?)/;
		var result = str.split(regex);
		var data='<div class="content" style="white-space: break-spaces;"><p>';
		for (var i=0;i<result.length;i++)
		{
		if(result[i].indexOf("http")>=0){
		data= data+ " <a href="+result[i]+" target='_blank' style='color: white;text-decoration: underline;'>"+result[i]+"</a>";
		}
		else{
		data = data+" "+ result[i];
		}
		}
		data=data+"</p></div>";
		return data;
		}
		// document.getElementById("wrapper").innerHTML = data;
}

//Need to initialize the data property after a computed property
//has been calculated. This is the cleanest way I could think to do it
mounted() {
	 //alert('moiunt');
	(this as any).load_more_text=true;
	this.$data.selectedNumber = this.text_permissions[0];
}

updated() {
	if( this.text_permissions.length > 0) {
	this.$data.selectedNumber = this.text_permissions[0]
	}
}
AddToContact(){
 this.$emit('cancel','cancel_event');
}
 emaichangr_(indx,evn){  
           this.$data.email_data=this.$data.FromSelected_Number=evn.phone_number;
      }
	Onchange_getext(indx,evn){
		this.$data.FromSelected_Number=evn.phone_number;;//event.target.value;
		//this.$data.EnableMSG_Number=num;
		this.$store.commit('SET_ONCHANGETEXTNUMBER_STATUS',true);
		//var Onchange_number= (this as any).Onchange_textnumberstatus;
		 this.$store.commit('SET_NUMBER_BEING_CALLED', null);
		this.getTexts();
	}

	// Called from the dashboard component. Used to set the selected
	// number when a notification is clicked.
	setSelectedNumber(notification_number) {
		for(const number of this.text_permissions) {
		if (notification_number === (number as any).phone_number) {
		this.$data.selectedNumber = number;
		this.getTexts();
		break;
		}
		}
	}

		// "If a user has privilege level none for a phone number then the user
		// should not be able to use that number for texting. This means that number
		// should not be displayed/included in the from dropdown described above."
		// -Section 3.2.1
		get text_permissions() {
			if(store.state.account.text_permissions && Array.isArray(store.state.account.text_permissions)) {
			return store.state.account.text_permissions.filter((e) => {
			return (e as any).text_permissions_level !== "none";
			});
			} else {
			return [];
			}
		}

// "If the caller/contact does not have a number that is
// text enabled, or the contact did not give permission to be sent texts,
// then leave the Text Messages tile empty/unpopulated and greyed out
// (i.e. inactive)." - Section 3.2.1

//Also checking to see if the user has any devices with text permission,
//and whether the contact has a mobile number
	get tileEnabled() {
		//alert('tileEnabled')
		if
		(
		this.text_permissions &&
		this.text_permissions.length > 0 &&
		this.selectedContact &&
		(this.selectedContact as any).numbers &&(
		(this.selectedContact as any).numbers.mobile ||
		(this.selectedContact as any).numbers.main)
		)
		{
		return true;
		}
		return false;
	}

//This check is run to see if the input area should be disabled
	get canSend() {
			if(
			this.$data.selectedNumber &&
			this.$data.selectedNumber.text_permissions_level === "full_access"
			)
			{
			return true;
			}
			return false;
	}

	get fullName() {
		if(this.selectedContact) {
		return `${(this.selectedContact as any).first_name} ${(this.selectedContact as any).last_name}`;
		}
		return "";
	}

// This is only here to make working with v-for easier.
get reverseLog() {
this.$data.temp_Textlist=(this as any).text_history.slice();
return this.$data.temp_Textlist;
}

	@Watch('text_history')
	Loadmoretext() 
	{
		let loadmore = false;
		if((this as any).text_history.length>0) {
			this.$data.temp_Textlist=(this as any).text_history.slice();
			const timestamp = (this as any).text_history[0].time;
			var fromdate = this.$data.minDate;
			loadmore = moment(timestamp).isAfter(fromdate, 'day') && (this as any).load_more_text;	
			
		}
		
		if (loadmore &&  this.downloading)
		{
		this.loadCheck();
		}
		else if (this.downloading)
		{
		this.downloading=false;
		var self =this;
		setTimeout(function(){
		self.TextExcelDoc_download();   
		}, 1000);
		}
	}

@Watch('number_being_called')
onNumberBeingCalledChange() {
  this.setSelectedNumber((this as any).number_being_called);
}



	@Watch('incoming_text')
	onIncomingText() { 
	//	alert('incoming_text')
		this.$data.EnableMSG_Number=(this as any).onchange_textnumber;
		if(	((this as any).incoming_text.to ===this.$data.selectedNumber.phone_number && 
		(this as any).incoming_text.from ===  this.$data.EnableMSG_Number) ||
		((this as any).incoming_text.from ===  this.$data.EnableMSG_Number &&
		(this as any).incoming_text.to === (this as any).selectedContact.numbers.mobile.number) )
		{
		var ntf= (this as any).incommingmessagenotification;
		this.$store.dispatch('markNotificationAsRead', ntf);

		this.$store.commit('DELETE_NOTIFICATION', {notificationId:ntf.id});
		this.$store.commit('APPEND_NEW_TEXTS', [(this as any).incoming_text]);
		var scrolldown;// = setTimeout(this.scroTobottom, 1000);
		var myDiv=(this as any).$refs.text_log;
		//myDiv.scrollTop = myDiv.scrollHeight+ 200;
		scrolldown = setTimeout(this.scroTobottomtext, 1000);
		}
	}  

	//Need to make an API request when the selected contact changes
	@Watch('selectedContact')
	onSelectedContactChange() {
		
		var selectedCont=(this as any).selectedContact;   
		if (!selectedCont) return; 
		this.$store.commit('SET_ONCHANGETEXTNUMBER_STATUS',false);
		var meg_number=(this as any).selectedContact.numbers.mobile.number; 
		if (meg_number.length<1 && (this as any).selectedContact.numbers.main.length>0)
		meg_number = (this as any).selectedContact.numbers.main[0]
		meg_number=meg_number==""?(this as any).selectedContact.numbers.main[0]:meg_number;
		this.$store.commit('SET_NUMBER_ONCHANGE_TEXTMESSG',meg_number)
		this.Contact_numbers;
		this.$data.outbound_start_timestamp = null;
		this.$data.inbound_start_timestamp = null;
		this.$data.Loader=false;
		this.$data.start_date=null;
		this.$data.end_date=null  ;
		this.getTexts();
		// var scrolldown;
		// scrolldown = setTimeout(this.scroTobottom, 1000);
	}

	scroTobottom()
	{  
		//    var objDiv = document.getElementById("your_div");
		//    if(objDiv!=null)
		//    objDiv.scrollTop = objDiv.scrollHeight+ 200;
		// Get the first element with the given class name
		var focs=(this as any).focus_ontext;
		console.log(focs)
		this.$data.text_focus=focs;
		let el = document.getElementById(focs);
		var objDiv = document.getElementById("your_div");
		var myDiv=(this as any).$refs.text_log;
		this.$store.commit('SET_FOCUSTEXT', '');
		// Get the bounding rectangle so we can get the element position position
		if(el==null && objDiv!=null)
		{
		//myDiv.scrollTop = myDiv.scrollHeight+ 200;
		}		
		else{
		el.scrollIntoView({ block: 'end'});
		}			   	 
		// if(focs==''){
		//     var objDiv = document.getElementById("your_div");
		// 			// if(objDiv!=null)
		// 			// objDiv.scrollTop = objDiv.scrollHeight+ 200;
		// 	}
		// else{
		// 	let el = document.getElementById(focs);  
		//     if(el!=null)
		// 	el.scrollIntoView({ block: 'end'});
		//  }
	}; 

		async sendText() {

			var myDiv=(this as any).$refs.text_log_123;

			var objDiv = document.getElementById("your_div"); 

			 myDiv.style.height ="30px";//'auto'; 
	   objDiv.style.height="358px";   
				objDiv.style.maxHeight="358px";   

			this.$store.commit('SET_FOCUSTEXT', ''); 
			var data=this.$data.temp_Textlist ;
			
				if (this.$data.textContent.length>0)
				{
				this.$data.msg_que.push(this.$data.textContent);
				this.$data.textContent = "";
				}
				if (!this.$data.sendingText && this.$data.msg_que.length >0) {
				var meg_number=(this as any).selectedContact.numbers.mobile.number; 
				if (meg_number.length<1 && (this as any).selectedContact.numbers.main.length>0)
				meg_number = (this as any).selectedContact.numbers.main[0];
				var Onchange_number= (this as any).Onchange_textnumberstatus;
				meg_number=Onchange_number?this.$data.EnableMSG_Number: meg_number;
				var bb=(this as any).selectedContact;			
				const  payload = { 
				from:   this.$data.FromSelected_Number.toString().indexOf("-1") > -1 ? this.$data.FromSelected_Number : "+1"+this.$data.FromSelected_Number,// this.$data.selectedNumber.phone_number,
				to: meg_number.toString().indexOf("-1") > -1 ? meg_number : "+1"+meg_number,
				content: this.$data.msg_que[0],
				contactct:(this as any).selectedContact
				}
				this.$data.msg_que.shift();
				try {
				this.$data.sendingText = true;
				await this.$store.dispatch('sendText', payload).then((r)=>{
				
				const msgID = r.data.id;
				r.data.direction= "out";
				let d= new Date();					 
				r.data.time=  d;
				const strdate= moment(r.data.time).format('YYYY-MM-DD');
				r.data.datex=strdate;					
				var index1 = this.$data.temp_Textlist.findIndex(x => x.datex ===strdate);
				r.data.displaydate=index1<0;
				r.data.messageId=msgID;
				
				r.data.deliveryState = 'Sending...';
				this.$data.temp_Textlist.push(r.data);
				(this as any).text_history.push(r.data);
				var data=(this as any).text_history;
				
				this.text_limitcal(data);
				this.loadCheck();
				var scrolldown; 
				const getmessgeinfo=  this.getmessgeinfo;
				var myDiv=(this as any).$refs.text_log;
				//myDiv.scrollTop = myDiv.scrollHeight+ 200;
				scrolldown = setTimeout(this.scroTobottomtext, 1000);
				setTimeout(function() {
				getmessgeinfo(msgID,false)
				}, 10000)

				this.$data.sendingText = false;
				;
				this.sendText();
				}
				);
				} catch(e) {
				console.warn(e)
				} finally {
				this.$data.sendingText = false;				
				}
				}
				else
				{
				}
				return;
		}

	scroTobottomtext(){  
		var myDiv=(this as any).$refs.text_log;
		this.$store.commit('SET_FOCUSTEXT', '');
		// Get the bounding rectangle so we can get the element position position
		myDiv.scrollTop = myDiv.scrollHeight+ 200;
	}; 


	getmessgeinfo(msgID,updatedeliverystatus,messagedata=null)
			{
				this.$store.dispatch('getMsgReceipt', msgID).then(r => {
					//alert(JSON.stringify(r))
				if (messagedata==null)
				{
				let array = this.$data.temp_Textlist;
				const filteredMsg = array.filter(ob => ob.messageId === msgID);
				messagedata=filteredMsg[0];
				}
				messagedata.state = r.data.state;
				var deliveryState= r.data.deliveryState;
				messagedata.deliveryState = deliveryState==='Waiting'? 'not-delivered':deliveryState;
				//	this.$data.temp_Textlist = [...toRemain, ...filteredMsg];
				if (updatedeliverystatus && messagedata.deliveryState!='Waiting')
				{
				this.$store.dispatch('updateDeliveryStatus',messagedata).then(r => {
				});
			}
		});
		}

	formatPhoneNumber(phoneNumber:string) {
	 if(typeof phoneNumber === "number") {
     phoneNumber = (phoneNumber as any).toString();
			}
				//This regex is based off the format of phone numbers
				//as they are returned in the contact list by the Kazoo API.
				//Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
				//If the Hellospoke database uses a different format will adjust
				//the pattern accordingly
				const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
				const matches = phoneNumber.match(re);
				if(matches === null) {
												console.log("The phone number " + phoneNumber + " could not be parsed");
								return "";
				}
				return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
	}

		//(this as any).number_being_called will be set from notificaton(Alert)
		getTexts() {  
			this.$data.FromSelected_Number=(this as any).Onchange_textnumberstatus?this.$data.FromSelected_Number: this.text_permissions[0].phone_number;//:this.$data.FromSelected_Number;
			this.$data.selectedNumber=(this as any).number_being_called==null? this.$data.FromSelected_Number :(this as any).number_being_called;
			(this as any).load_more_text=true;
				if ((!(this as any).selectedContact)  ||!(this as any).selectedContact.numbers)
				return;
				var meg_number=(this as any).selectedContact.numbers.mobile.number; 
				if (meg_number.length<1 && (this as any).selectedContact.numbers.main.length>0)
				meg_number = (this as any).selectedContact.numbers.main[0];
				meg_number=meg_number==""?(this as any).selectedContact.numbers.main[0]:meg_number;
				var Onchange_number= (this as any).Onchange_textnumberstatus;  
				this.$data.EnableMSG_Number=Onchange_number?this.$data.EnableMSG_Number: meg_number;
				meg_number=Onchange_number?this.$data.EnableMSG_Number: meg_number;
				this.$store.commit('SET_NUMBER_ONCHANGE_TEXTMESSG',meg_number)	;
				this.$data.Loader=true;
				this.$data.temp_Textlist=[];
		
				this.$store.dispatch("getTextHistory", {
				num1: meg_number, 
				num2: this.$data.FromSelected_Number//"15022646954",//
				}).then((r) => {
					
			var data=this.$data.temp_Textlist;//=(this as any).text_history.slice();
			this.text_limitcal(data);
			
				this.$data.Loader=false;
				if(this.$refs.text_log) { 
				(this.$refs.text_log as any).scrollTop = (this.$refs.text_log as any).scrollHeight;
				}
				this.$data.temp_Textlist=(this as any).text_history.slice();

				// this.loadCheck();
				var scrolldown;
				
				scrolldown = setTimeout(this.scroTobottom, 1000);
				this.$data.temp_Textlist.forEach(element => {
					if(element.deliveryState=="waiting"){
     				this.getmessgeinfo(element.messageId,true);
				}
				});
				var ntf= (this as any).incommingmessagenotification;
				this.$store.dispatch('markNotificationAsRead', {notificationId:'12',number:meg_number});
				this.$store.commit('DELETE_NOTIFICATION', {notificationId:'12',number:meg_number}); 
      //alert(r)
      //this.$data.notinction_loader=false
   
			
				}).catch((r) => {
				this.$data.Loader=false;
				//this.$data.temp_Textlist=[];
				});
		}
	
	text_limitcal(data){
   var dt = new Date();
			var startDate =this.$data._sdate= new Date(dt.getFullYear(), dt.getMonth(), 1);
			var endDate = this.$data._edate=new Date();
			const pastDates = data.filter(x => Date.parse(x.time) >  Date.parse(this.$data._sdate) && Date.parse(x.time) <=  Date.parse(this.$data._edate) );
  var outbound_messages = [];
   pastDates.forEach(doc => {
			if(doc.direction=="out"){
      outbound_messages.push(doc);
			 }
					});
			this.$store.commit('SET_TEXT_LIMIT',outbound_messages.length);
	}

		get Contact_numbers(){
			var jnb=(this as any).selectedContact;   
			if (!jnb) return; 
			this.$data.Main_Number=jnb.numbers.main[0]; 
			this.$data.Mobile_Number=jnb.numbers.mobile.number;
			this.$data.MsgNumbers=[];
			if(this.$data.Main_Number!="" && this.$data.Mobile_Number!=""){
			if(this.$data.Main_Number== this.$data.Mobile_Number){
			this.$data.MsgNumbers.push( {num:this.$data.Main_Number,_id:0} );  
			}
			else{
			this.$data.MsgNumbers.push( 
			{num:this.$data.Main_Number  ,_id:0} ,
			{num:this.$data.Mobile_Number,_id:1});  
			}
			}
			if(this.$data.Main_Number=="" && this.$data.Mobile_Number!="") { 
			this.$data.MsgNumbers.push({num:this.$data.Mobile_Number,_id:0} );  
			}
			if(this.$data.Main_Number!=""&& this.$data.Mobile_Number=="") { 
			this.$data.MsgNumbers.push(  {num:this.$data.Main_Number,_id:0} );  
			}

			return this.$data.MsgNumbers;
		} 

		loadCheck(e=null) {
				if(
				(!this.downloading&&
				this.$refs.text_log && (this.$refs.text_log as any).scrollTop === 0 &&
				this.selectedContact &&
				(this as any).selectedContact.numbers &&
				(this as any).selectedContact.numbers.mobile &&
				(this as any).selectedContact.numbers.mobile.number &&
				this.$data.selectedNumber &&
				this.$data.selectedNumber.phone_number &&
				(this as any).text_history.length > 0
				)
				||
				(this.downloading && e==null)
				//	&& (this as any).load_more_text
				) 

				{

				//	this.$data.Loader=true;
				const init_height = (this as any).$refs.text_log.scrollHeight;
				const timestamp = (this as any).text_history[0].time;
				//	this.$data.Loader=true;
				//const timestamp =  (this as any).temp_Textlist[(this as any).text_history.length - 1].time; //this.$data.temp_Textlist
				this.$store.dispatch('loadMoreTexts', {
				num1: (this as any).selectedContact.numbers.mobile.number,
				num2: this.$data.selectedNumber.phone_number,
				timestamp
				}).then((r) => {
					//alert(r)
				if (!this.downloading){
				this.$data.Loader=false;
				const new_height = (this as any).$refs.text_log.scrollHeight;
				(this.$refs.text_log as any).scrollTop += (new_height - init_height);
				var scrolldown;
				scrolldown = setTimeout(this.scroTobottom, 1000);
				}
				//this.downloading=false;
				});
				}
		} 
 
	fileUploaded(files) {
		var FileSize=files[0].size;
		var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
		if(Max_fileSize>4)
		{
		alert('Attachment may not exceed 5MB.');
		}
		else{ 
		this.$data.sendingImage = true;
		let formData = new FormData();
		var to=(this.selectedContact as any).numbers.mobile.number==''? (this.selectedContact as any).numbers.main[0]:(this.selectedContact as any).numbers.mobile.number;
		formData.append('file', files[0]);
		formData.append('from', this.$data.selectedNumber.phone_number);
		formData.append('to', to);
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
		axios.post( `${AppSettings.API_HOST}sendMMSFile`,formData,{	headers: {'Content-Type': 'multipart/form-data'}})
		.then(r => {
					(this.$refs.fileInput as any).value = null;
					this.$data.sendingImage = false;
					r.data.direction= "out";
					let d= new Date(); 
					r.data.time=  d;
					const strdate= moment(r.data.time).format('YYYY-MM-DD');
					r.data.datex=strdate;
					var index1 = this.$data.temp_Textlist.findIndex(x => x.datex ===strdate);
					r.data.displaydate=index1<0;
					this.$data.temp_Textlist.push(r.data);
					(this as any).text_history.push(r.data);
			var data=(this as any).text_history;
			this.text_limitcal(data);
		
					this.loadCheck();
					var scrolldown;
					var myDiv=(this as any).$refs.text_log;
					myDiv.scrollTop = myDiv.scrollHeight+ 200;
					scrolldown = setTimeout(this.scroTobottomtext, 1000);
		//scrolldown = setTimeout(this.scroTobottom, 1000);
		})
		.catch(r => {
		this.$data.sendingImage = false;
		(this.$refs.fileInput as any).value = null;
		console.log('failed', r);
		});
		}
		}

		isImage(media) {
		const re = /.+\.(png|jpeg|jpg|gif|PNG|JPEG|JPG|GIF|)/;
		return re.test(media);
		}

		getBandwidthTimestamp(d) {
		return moment(d).format('YYYY-MM-DD HH:mm:ss');
		}

		//Used to add a bold class to the selected option element in the phone
		// - Page 40 in dashboard v1-1
		shouldBold(number: any) {
		if(number === this.$data.selectedNumber) {
		return "bold"
		}
		}

		downloadXCLDOC() {
			if(this.$data.temp_Textlist.length!=0)
			var self=this;
			const timestamp = (this as any).text_history[0].time;
			if (this.$data.start_date==null && this.$data.end_date==null
			||(this.$data.start_date!==null&&this.$data.end_date==null) 
			|| (this.$data.start_date==null&&this.$data.end_date!==null))
			{ 
			this.$data.date_status=true;
			}
			else
			{
			this.downloading=true;
			this.$data.date_status=false;
			setTimeout(function(){  
			self.TextExcelDoc_download();   
			}, 1000);
			}
		}


		/**
		* Download message history to  ExcelDoc file 
		*/
	public TextExcelDoc_download() {
		this.downloading=false; 
		var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
		var Contact_User;
		if((this as any).selectedContact) {
		Contact_User =`${((this as any).selectedContact as any).first_name} ${((this as any).selectedContact as any).last_name}`;
		}
		else {
		Contact_User= '';
		}
		let Contact_Number ;
		if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.mobile && (this as any).selectedContact.numbers.mobile.number) {
		Contact_Number= (this as any).selectedContact.numbers.mobile.number;
		}
		else {
		Contact_Number= '';
		}
		let Custemer_ID ;
		if(((this as any).selectedContact as any).custermerid )
		{
		Custemer_ID= ((this as any).selectedContact as any).custermerid ;
		}
		else {
		Custemer_ID= '';
		}
		var fromdate = this.$data.minDate;//this.$data.start_date;//
		var todate=	this.$data.maxDate ? this.$data.maxDate  : new Date();//this.$data.end_date;//
		var wb = XLSX.utils.book_new();
		var L1;
		var L2;
		L1=moment(fromdate).format('YYYY-MM-DD');//fromdate;//this.$data.start_date;//
		L2=moment(todate).format('YYYY-MM-DD');//todate;// this.$data.end_date;//
		var data = [
		['Message History'],
		['Start Date', L1],
		['End Date',L2],
		['User', Login_User,+48646546 ],
		['Contact', Contact_User, Contact_Number],
		['Customer ID',  Custemer_ID],
		[''],
		['Date','Time','Person','Message'],
		];
		this.$data.temp_Textlist.forEach(obj =>{ 

		if (moment(obj.time).isSameOrAfter(fromdate, 'day') 
		&& moment(obj.time).isSameOrBefore(todate, 'day')
		)
		{
		var sendername= obj.direction=="in"?Contact_User:Login_User;
		data.push([moment(obj.time).format('YYYY-MM-DD'),moment(obj.time).format('h:mm A') ,sendername, obj.text]);
		}
		});
		var Chat_from =this.$data.temp_Textlist[0].from;
		Chat_from='HelloSpoke chat with'+' '+ Chat_from;
		var append_sheet='HelloSpoke chat with'+' '+this.$data.temp_Textlist[0].from;
		Chat_from=Chat_from+'.'+"xlsx";

		var wb = XLSX.utils.book_new();
		var ws = XLSX.utils.json_to_sheet(data, {skipHeader: true,cellDates:true});
		var range = XLSX.utils.decode_range(ws["!ref"]);
		if(!ws['!cols']) ws['!cols'] = [];
		if(!ws.A1.c) ws.A1.c = [];
		//  ws.A1.c.push({a:"SheetJS", t:"This comment is visible"});
		/* TEST: merge cells */
		ws['!merges'] = [ XLSX.utils.decode_range("A1:B1") ];
		ws['!cols'][0] = { wch: 15 };
		ws['!cols'][1] = { wch: 15 };
		ws['!cols'][2] = { wch: 25 };
		ws["!margins"]={left:6.0, right:8.0, top:9.0, bottom:1.0, header:0.5,footer:0.5};
		XLSX.utils.book_append_sheet(wb, ws, "No Header");
		var wbout = XLSX.write(wb, {bookType:'xlsx', type:'array'});
		saveAs(new Blob([wbout],{type:"application/octet-stream"}), Chat_from); 
		}



}
